import styled from "@emotion/styled";
import { Pagination } from "@mui/material";

interface TablePaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
  className?: string;
}

export const TablePagination = ({
  page,
  totalPages,
  onPageChange,
  className,
}: TablePaginationProps) => (
    <StyledFooterContent className={className}>
      <PaginationWrapper>
        <StyledPagination
          size="small"
          color="primary"
          variant="text"
          shape="circular"
          hideNextButton={false}
          hidePrevButton={false}
          showFirstButton
          showLastButton
          count={totalPages}
          page={page}
          onChange={onPageChange}
        />
      </PaginationWrapper>
    </StyledFooterContent>
  );

const StyledFooterContent = styled.div`
  display: flex;
  justify-content: center;
  min-height: 52px;
  // border-top: 1px solid rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
`;

const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 16px;
  height: 52px;
`;

const StyledPagination = styled(Pagination)`
  && {
    .MuiPagination-ul {
      gap: 6px;
      display: flex;
      align-items: center;
    }

    .MuiPaginationItem-root {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1; // 라인 높이 조정으로 숫자 정렬 보정
      margin: 0;
      padding: 0;
    }

    .MuiPaginationItem-page {
      font-size: 14px;
      height: 26px;
      min-width: 26px;
    }
  }
`;
